import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import useTranslation from '@src/hooks/useTranslation';
import { useRouter } from 'next/router';

import Breadcrumb from '@src/components/common/breadcrumb';
import { getCategories } from '@src/store/selectors/category';
import { IHierarchy } from '@src/types/category';

import './global.module.less';

const Content = styled.div`
	background: #F5F5F7;
	padding: 12px 20px;
	width: 100%;
`;

const Split = styled.span`
	padding: 0px 4px;
`;

const BreadcrumbContent = (
	{ path, onFilterChange }:
	{ path: IHierarchy[], onFilterChange: (data) => void },
): JSX.Element => {
	const categories = useSelector(getCategories);
	const { t } = useTranslation();
	const router = useRouter();

	const breadcrumbConfig = [
		{ name: t('breadcrumb:home'), path: '/training' },
		{ name: t('category:breadcrumb:categoryPath'), path: '/category/all' },
	];
	if (path.length === 0) {
		breadcrumbConfig.push({ name: t('category:all_category'), path: '' });
	}
	path.forEach(p => {
		const category = _.find(categories, { id: p.id });
		if (category) {
			breadcrumbConfig.push({
				name: category?.name,
				path: `/category/${category?.short_link}`,
			});
		}
	});

	return (
		<Content>
			<Breadcrumb
				breadcrumbConfig={breadcrumbConfig}
				splitIcon={<Split>/</Split>}
				onClick={(p: string) => {
					const shortLink = p.split('/').pop();
					if (shortLink === '/') {
						router.push('/training');
					} else {
						onFilterChange({ category_short_link: shortLink === 'all' ? '' : shortLink });
					}
				}}
			/>
		</Content>
	);
};

export default BreadcrumbContent;
